import React, {ReactElement} from 'react';
import {lazy} from 'shared/utils/lazy';
import {useDispatch} from 'ui/store';
import {useUIStore} from 'store/UI';
import {useIsRefillEnabled} from 'store/CoreSettings';

import {
  useKeyboard,
  addSymbol as addSymbolAction,
  handleCommand as handleCommandAction,
} from 'store/UserInput';

import {
  KeyboardSymbolKind,
  isEmpty,
  createSymbol,
  clearSymbol as clear,
  commaSymbol as comma,
  backspaceSymbol as backspace,
} from 'ui/keyboard';

import {Center} from 'components/Center';
import {Key} from 'components/Key';
import {Enter} from './Enter';
import {Wrapper, Grid, Left, Right, Cell} from './style';
import {ModeToggle} from './ModeToggle';

function fromNumber(number: number): KeyboardSymbol {
  return createSymbol(KeyboardSymbolKind.Number, number);
}

export const Keyboard = (): ReactElement => {
  const {settingsVisible} = useUIStore();
  const isRefillEnabled = useIsRefillEnabled();

  const zero = fromNumber(0);
  const keyboard = useKeyboard();
  const addSymbol = useDispatch(addSymbolAction);
  const handleCommand = useDispatch(handleCommandAction);
  const showToggleMode = isRefillEnabled && !settingsVisible;

  return (
    <Wrapper>
      <Center className='center'>
        <Grid>
          <Left>
            {[7, 8, 9, 4, 5, 6, 1, 2, 3].map((number) => {
              const symbol = fromNumber(number);
              return (
                <Cell key={number}>
                  <Key symbol={symbol} onPress={lazy(addSymbol, symbol)} />
                </Cell>
              );
            })}

            <Cell width='66.66%'>
              <Key className='zero' symbol={zero} onPress={lazy(addSymbol, zero)} />
            </Cell>

            <Cell>
              <Key symbol={comma} onPress={lazy(addSymbol, comma)} />
            </Cell>
          </Left>

          <Right>
            <Cell width='100%' data-test='backspace'>
              <Key
                symbol={backspace}
                onPress={lazy(handleCommand, backspace)}
                onLongPress={lazy(handleCommand, clear)}
                disabled={isEmpty(keyboard)}
              />
            </Cell>

            {showToggleMode && (
              <Cell width='100%' height='25%'>
                <ModeToggle />
              </Cell>
            )}

            <Cell width='100%' height={showToggleMode ? '50%' : '75%'}>
              <Enter />
            </Cell>
          </Right>
        </Grid>
      </Center>
    </Wrapper>
  );
};
